const ENV = {
  API_URL: process.env.API_URL,
  MAPBOX_API_KEY: process.env.MAPBOX_API_KEY,
};

export const getEnv = (key: keyof typeof ENV): string => {
  return (window as any)?.__env ? ((window as any).__env[key] as string) : (ENV[key] as string);
};
